export default __webpack_public_path__ + "static/media/image-cushion-r-w@2x.c2cb387f.webp";